export const aboutData = {
  brandIntro: {
    title: "关于17.c 起草在线观看免费版",
    subtitle: "致力于为用户提供便捷、高清的影视在线观看服务",
    description: "17.c 起草在线观看免费版是一个专注于影视内容聚合与在线观看的平台。自成立以来，我们始终坚持以用户体验为核心，不断优化播放技术，丰富内容资源，为用户打造一个方便快捷、高清流畅的观影环境。",
    image: "https://readdy.ai/api/search-image?query=Modern%20media%20streaming%20office%20with%20creative%20team%20collaboration%2C%20warm%20ambient%20lighting%2C%20golden%20and%20coral%20tones%2C%20professional%20workspace%2C%20clean%20minimal%20design&width=800&height=500&seq=about-brand-01&orientation=landscape",
    features: [
      { icon: "ri-movie-line", title: "海量资源", desc: "覆盖电影、电视剧、综艺、动漫等多种类型，每日更新最新内容" },
      { icon: "ri-hd-line", title: "高清画质", desc: "支持4K超高清播放，还原影院级视觉体验" },
      { icon: "ri-speed-line", title: "流畅播放", desc: "多线路智能切换，确保播放不卡顿" },
      { icon: "ri-shield-check-line", title: "安全可靠", desc: "严格内容审核，无病毒无恶意广告" },
    ],
  },
  reputation: {
    title: "用户口碑",
    subtitle: "来自17.c 起草在线观看免费版用户的真实评价",
    reviews: [
      { name: "王**", rating: 5, comment: "17.c 起草在线观看免费版真的很好用，片源更新快，画质清晰，播放也很流畅，已经推荐给身边的朋友了。", date: "2026-07-30" },
      { name: "李**", rating: 5, comment: "用了很多在线观看平台，17.c 起草是体验最好的一个。界面简洁不花哨，分类清楚，找片很方便。", date: "2026-07-28" },
      { name: "张**", rating: 4, comment: "资源很丰富，基本上想看的都有。播放速度很快，几乎不卡顿，17.c 起草在线观看免费版值得拥有。", date: "2026-07-25" },
      { name: "刘**", rating: 5, comment: "最喜欢17.c 起草的无广告体验，观影过程很舒心。高清画质在手机上也很棒！", date: "2026-07-22" },
      { name: "陈**", rating: 5, comment: "朋友推荐的17.c 起草在线观看免费版，用了一次就爱上了。分类齐全，更新及时，周末追剧首选。", date: "2026-07-20" },
      { name: "赵**", rating: 4, comment: "17.c 起草的资源质量很高，纪录片和电影资源尤其丰富。希望继续保持这样的更新频率。", date: "2026-07-18" },
    ],
    stats: [
      { label: "注册用户", value: "500万+" },
      { label: "日均播放", value: "2000万+" },
      { label: "内容数量", value: "10万+" },
      { label: "好评率", value: "98.5%" },
    ],
  },
  contact: {
    title: "联系我们",
    subtitle: "如有任何问题或建议，欢迎通过以下方式与我们联系",
    email: "contact@17c-drafting.com",
    phone: "400-123-4567",
    address: "北京市朝阳区建国路88号SOHO现代城A座",
    workingHours: "周一至周日 9:00 - 21:00",
  },
};